// Lê a aba inicial do dashboard a partir de ?tab=... (links das notificações)
// e limpa o parâmetro da URL pra não reabrir a mesma aba ao recarregar.
export function getInitialTab(validTabs, fallback) {
  try {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get("tab");

    if (!tab) return fallback;

    params.delete("tab");
    const query = params.toString();
    window.history.replaceState(null, "", window.location.pathname + (query ? `?${query}` : "") + window.location.hash);

    return validTabs.includes(tab) ? tab : fallback;
  } catch {
    return fallback;
  }
}
